<template>
    <div class="container-fluid">
        <div v-if="id" class="modal-backdrop fade show"></div>
        <app-event
            v-if="id == 'event'"
            :id="id == 'event'"
            :event="data.id"
            :submit="submit == 'event'"
            :reject="false"
            :approve="false"
            @onClose="() => { id = null, submit = null, this.onInit() }"
            :countries="countries"
            @onEvent="onEvent">
        </app-event>
        <div class="card bg-light-info shadow-none position-relative overflow-hidden">
            <div class="card-body px-4 py-3">
                <div class="row align-items-center">
                    <div class="col-9">
                        <h4 class="fw-semibold mb-8">Mis citas</h4>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link class="text-muted" :to="{ name: 'Home' }">Inicio</router-link>
                                </li>
                                <li class="breadcrumb-item" aria-current="page">
                                    Mis citas
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div class="col-3">
                        <div class="text-center mb-n5">
                            <img src="@/assets/images/breadcrumb/ChatBc.png" alt="" class="img-fluid mb-n4">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div>
                <div class="row gx-0">
                    <div class="col-lg-12">
                        <div class="p-4 calender-sidebar app-calendar">
                            <div class="fc fc-media-screen fc-direction-ltr fc-theme-standard">
                                <div class="fc-header-toolbar fc-toolbar fc-toolbar-ltr">
                                    <div class="fc-toolbar-chunk">
                                        <v-btn fab text small color="grey darken-2" @click="prev">
                                            <v-icon small>
                                                chevron_left
                                            </v-icon>
                                        </v-btn>
                                        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">Today</v-btn>
                                        <v-btn fab text small color="grey darken-2" @click="next">
                                            <v-icon small>
                                                chevron_right
                                            </v-icon>
                                        </v-btn>
                                    </div>
                                    <div class="fc-toolbar-chunk">
                                        <h2 class="fc-toolbar-title" id="fc-dom-1">
                                            <v-toolbar-title v-if="$refs.calendar">
                                                {{ $refs.calendar.title }}
                                            </v-toolbar-title>
                                        </h2>
                                    </div>
                                    <div class="fc-toolbar-chunk">
                                        <div class="fc-button-group">
                                            <v-select
                                                v-model="type"
                                                :items="types"
                                                class="form-control ma-2"
                                                dense
                                                outlined
                                                hide-details>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <v-app style="height: 100vh !important;">
                                    <v-calendar
                                        ref="calendar"
                                        v-model="focus"
                                        :events="events"
                                        :event-overlap-mode="mode"
                                        :event-overlap-threshold="30"
                                        @click:event="onEvent"
                                        :event-color="getEventColor"
                                        :type="type">
                                    </v-calendar>
                                </v-app>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import AppEvent from '@/pages/calendar/events/Event'
export default {
  components: { AppEvent },
  data: () => ({
    today: moment(new Date()).format('Y-M-D'),
    events: [],
    mode: 'stack',
    type: 'week',
    types: ['month', 'week', 'day'],
    colors: ['blue', 'green', 'red'],
    focus: '',
    data: {},
    id: null,
    submit: null,
    countries: []
  }),
  created () {
    this.onInit()
  },
  methods: {
    onInit: function () {
      this.submit = 'table'
      this.$axios({
        url: '/my/appointments',
        method: 'GET'
      })
        .then((resp) => {
          this.events = resp.data
        })
        .finally((resp) => {
          this.submit = ''
          this.$axios({
            url: '/countries',
            method: 'GET'
          })
            .then((resp) => {
              this.countries = resp.data
            })
        })
    },
    onEvent: function (e) {
      this.id = 'event'
      this.submit = null
      this.data = e.event
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    getEventColor (event) {
      return event.state === 1 ? 'green' : event.state === 2 ? 'red' : 'blue'
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    }
  },
  mounted () {
    this.$refs.calendar.scrollToTime('08:00')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/calendar/MyAppointments.vue